/**
 * 追加入力項目用
 */

var OrderOption = OrderOption || {};

OrderOption.searchHistory = function() {
    var defer = $.Deferred();
    $.ajax({
        url: '/service/order-option-history.json',
        method: 'GET',
        dataType:'json',
        cache: false,
        success: defer.resolve,
        error: defer.reject
    });
    return defer.promise();
};
